<table>
  <tbody>  
    <tr *ngFor="let question of questions">
      <xcm-dynamic-view-question [question]="question"></xcm-dynamic-view-question>
    </tr>
  </tbody>
</table>